import React from "react";
import useAccessCheck from "../../../hooks/useAccessCheck";
import {CompanyRole, PublishStatusType} from "../../../core/enums/enums";
import {useAcceptModalContext} from "../../../providers/AcceptModalProvider";
import {IDocument} from "../../../core/interfaces/document";
import {useUpdateDocumentVersion} from "../../../api/DocumentApi";
import {useGetUser} from "../../../hooks/useAuth";
import {Icon} from "../../../assets/Icons/IconClassNames";
import {CustomDropdownItem} from "../../../components/CustomDropdown/CustomDropdownItem/CustomDropdownItem";
import {addToast} from "../../../store/slices/uiSlice";
import {toastInfo} from "../../../core/helpers/toastHelper";
import {useAppDispatch} from "../../../store/hooks";

export const NewVersion = (
    {
        document,
        disabled,
        isEditMode,
        setEditMode
    }: { document: IDocument, disabled: boolean, isEditMode: boolean, setEditMode: (v: boolean) => void }) => {
    const dispatch = useAppDispatch();
    const [checkCompanyRole] = useAccessCheck();
    const user = useGetUser();
    const [request, isLoading] = useUpdateDocumentVersion(document.id);
    const acceptModalContext = useAcceptModalContext();
    const requestFunction = () => {
        request().then(success => {
            if (success) {
                setEditMode(false);
            }
        })
    }

    const handleCreateNewVersion = () => {
        if (isEditMode) {
            dispatch(addToast(toastInfo("Lämna redigeringsläge", "Vänligen lämna redigeringsläget.")));
            return;
        }
        acceptModalContext.trigger(requestFunction, {
            header: "Skapa ny version",
            declineButtonText: 'Stäng',
            acceptButtonText: 'Ja',
            body: <p>Är du säker på att du vill skapa en ny version? Du kommer inte kunna ändra föregående
                versioner.</p>
        })
    }

    return <CustomDropdownItem
        disabled={disabled || isLoading || !((checkCompanyRole(CompanyRole.ADMIN) || document?.createdBy?.id === user.userId) && document.publishStatus === PublishStatusType.APPROVED)}
        onClick={handleCreateNewVersion}
        text={"Skapa ny version"}
        icon={Icon.CODE_COMPARE}
    />
}